import {Translation} from './Translation';

const language: Translation = {
  common: {
    loading: 'Indlæser...',
    error: 'Fejl',
    success: 'Succes',
    cancel: 'Annuller',
    save: 'Gem',
    edit: 'Rediger',
    view: 'Vis',
    delete: 'Slet',
    draft: 'Udkast',
    drafts: 'Udkast',
    create: 'Opret',
    gettingStarted: 'Kom godt i gang',
    created: 'Oprettet',
    join: 'Deltag',
    leave: 'Forlad',
    of: 'af',
    accept: 'Accepter',
    decline: 'Afvis',
    continue: 'Fortsæt',
    back: 'Tilbage',
    next: 'Næste',
    close: 'Luk',
    search: 'Søg',
    filter: 'Filtrer',
    all: 'Alle',
    none: 'Ingen',
    yes: 'Ja',
    no: 'Nej',
    or: 'eller',
    and: 'og',
    with: 'med',
    at: 'på',
    from: 'fra',
    to: 'til',
    date: 'Dato',
    time: 'Tid',
    location: 'Lokation',
    details: 'Detaljer',
    chat: 'Chat',
    tasks: 'Opgaver',
    participants: 'Deltagere',
    attendees: 'Deltagere',
    email: 'E-mail',
    password: 'Adgangskode',
    name: 'Navn',
    title: 'Titel',
    description: 'Beskrivelse',
    required: 'Påkrævet',
    optional: 'Valgfri',
    invalid: 'Ugyldig',
    valid: 'Gyldig',
    empty: 'Tom',
    notFound: 'Ikke fundet',
    notAvailable: 'Ikke tilgængelig',
    comingSoon: 'Kommer snart',
    download: 'Download',
    upload: 'Upload',
    share: 'Del',
    copy: 'Kopier',
    refresh: 'Opdater',
    retry: 'Prøv igen',
    tryAgain: 'Prøv igen',
    somethingWentWrong: 'Noget gik galt',
    invalidCredentials: 'Ugyldige legitimationsoplysninger',
    accessDenied: 'Adgang nægtet',
    permissionDenied: 'Tilladelse nægtet',
    networkError: 'Netværksfejl',
    serverError: 'Serverfejl',
    unknownError: 'Ukendt fejl',
    start: 'Start',
    creating: 'Opretter...',
    user: 'Bruger',
    language: 'Sprog',
    notifications: 'Notifikationer',
    reminder: 'Reminder',
    reminders: 'Påmindelser',
    published: 'Publiceret',
    enableNotifications: 'Aktivér notifikationer',
    emailNotifications: 'E-mail notifikationer',
    pushNotifications: 'Push notifikationer',
    unlimitedColleagues: 'Ubegrænset kolleger',
    colleague: 'kollega',
    colleagues: 'kolleger',
    peopleRange: 'personer',
    profile: 'Profil',
    firstName: 'Fornavn',
    lastName: 'Efternavn',
    fullName: 'Fulde navn',
    bio: 'Bio',
    changePassword: 'Skift adgangskode',
    currentPassword: 'Nuværende adgangskode',
    newPassword: 'Ny adgangskode',
    confirmPassword: 'Bekræft adgangskode',
    today: 'I dag',
    tomorrow: 'I morgen',
    days: 'dage siden',
    weeks: 'uger siden',
    selected: 'valgt',
    more: 'flere',
    status: 'Status',
    interests: 'Interesser',
    searchPlaceholder: 'Søg efter navn, e-mail, jobtitel eller interesser...',
    clearAll: 'Ryd alt',
    selectInterestsToFilter: 'Vælg interesser at filtrere efter:',
    downloadToCalendar: 'Download til kalender',
    manuallyAddEmployee: 'Tilføj medarbejder manuelt',
    addEmployeeToEvent: 'Tilføj medarbejder til event',
    addEmployee: 'Tilføj medarbejder',
    noEmployeesFound: 'Ingen medarbejdere fundet der matcher din søgning.',
    noAvailableEmployees: 'Ingen tilgængelige medarbejdere at tilføje.',
    noColleaguesFound: 'Ingen kolleger fundet der matcher din søgning.',
    noColleaguesAvailable: 'Ingen kolleger tilgængelige at invitere.',
    searchEmployeesPlaceholder:
      'Søg efter navn, e-mail, jobtitel eller afdeling...',
    searchColleaguesPlaceholder:
      'Søg efter navn, e-mail, jobtitel eller afdeling...',
    addOption: 'Tilføj mulighed',
    avatar: 'Avatar',
    nameAndTitle: 'Navn & Titel',
    department: 'Afdeling',
    jobTitle: 'Jobtitel',
    company: 'Virksomhed',
    officeLocation: 'Kontor lokation',
    started: 'Startede',
    funFact: 'Fun fact',
    cards: 'Kort',
    table: 'Tabel',
    loadingInterests: 'Indlæser interesser...',
    noInterestsFound: 'Ingen interesser fundet.',
    searchInterests: 'Søg interesser...',
    cantFindWhatYoureLookingFor: 'Kan du ikke finde det du leder efter?',
    teamOnboarding: 'Team onboarding',
    loadingOnboardingProgress: 'Indlæser onboarding status...',
    failedToLoadOnboardingData: 'Kunne ikke indlæse onboarding data',
    unableToLoadOnboardingData: 'Kunne ikke indlæse onboarding data',
    teamMembersActive: 'team medlemmer aktive',
    activeMembers: 'Aktive medlemmer',
    active: 'Aktiv',
    pendingInvites: 'Afventende invitationer',
    pendingInvitesClickToView: 'Afventende invitationer (Klik for at se)',
    trackTeamOnboardingProgress:
      'Følg dit teams onboarding status og se hvem der stadig skal tilmelde sig.',
    allTeamMembersJoined: '🎉 Alle team medlemmer er tilmeldt!',
    almostThereMostTeamOnboard:
      '🚀 Næsten der! Det meste af dit team er ombord.',
    goodProgressMoreThanHalf:
      '📈 God fremgang! Mere end halvdelen af dit team er tilmeldt.',
    teamMembersStillJoining:
      '📨 Team medlemmer tilmelder sig stadig. Invitationer afventer.',
    gettingStartedTeamGrowing: '🌱 Kommer i gang! Dit team vokser.',
    loadingPendingInvites: 'Indlæser afventende invitationer...',
    noPendingInvitesFound: 'Ingen afventende invitationer fundet.',
    theseTeamMembersInvited:
      'Disse team medlemmer er blevet inviteret men er endnu ikke tilmeldt. Du kan sende deres invitation igen.',
    invited: 'Inviteret',
    recently: 'for nylig',
    sending: 'Sender...',
    reInvite: 'Gen-inviter',
    topInterests: 'Top interesser',
    noInterestDataAvailable: 'Ingen interesse data tilgængelig',
    changeEmoji: 'Skift emoji',
    pickEmoji: 'Vælg emoji',
    noEmojiSelected: 'Ingen emoji valgt...',
    whatNeedsToBeDone: 'Hvad skal der gøres?',
    createTask: 'Opret opgave',
    inviteEmployees: 'Inviter medarbejdere',
    inviteMessage: 'Invitations besked',
    enterCustomInviteMessage:
      'Indtast din brugerdefinerede invitations besked...',
    addEmailsWithCSVOrManually: 'Tilføj medarbejdere via CSV',
    downloadExampleCSV: 'Download eksempel CSV',
    processingCSVFile: 'Behandler CSV fil...',
    dragAndDropCSVFileHere: 'Træk og slip en CSV fil her, eller klik',
    orEnterEmailAddress: 'Eller indtast medarbejderoplysninger manuelt',
    add: 'Tilføj',
    emailsToInvite: 'E-mails at invitere',
    employeesToInvite: 'Medarbejdere at invitere',
    actions: 'Handlinger',
    invite: 'Inviter',
    users: 'brugere',
    pleaseEnterValidEmailAddress: 'Indtast venligst en gyldig e-mail adresse',
    pleaseFillRequiredFields: 'Udfyld venligst alle påkrævede felter',
    emailDomainNotAllowed: 'E-mail domæne er ikke tilladt. Tilladte domæner:',
    allowedDomains: 'Tilladte domæner:',
    thisEmailAlreadyInList: 'Denne e-mail er allerede på listen',
    noValidEmailsFoundInCSV: 'Ingen gyldige e-mails fundet i CSV filen',
    emailsRemovedBecauseNotMatch:
      'e-mails fjernet fordi de ikke matchede de tilladte domæner:',
    was: 'var',
    were: 'var',
    itDid: 'den gjorde',
    theyDid: 'de gjorde',
    notMatchAllowedDomains: 'ikke matche de tilladte domæner:',
    orWereDuplicates: 'eller var duplikater',
    errorParsingCSVFile: 'Fejl ved parsing af CSV fil',
    failedToInviteUsers: 'Kunne ikke invitere brugere',
    pendingInvitations: 'Afventende invitationer',
    invitedAt: 'Inviteret den',
    invitedBy: 'Inviteret af',
    selectOrTypeDepartments: 'Vælg eller skriv afdelinger...',
    ifNoDepartmentsSelectedEveryoneInvited:
      'Hvis ingen afdelinger er valgt, vil alle blive inviteret',
    allDepartmentsSelectedEveryoneInvited:
      'Alle afdelinger valgt, alle vil blive inviteret',
    moveToDeclined: 'Flyt til afvist',
    moveToAttending: 'Flyt til deltagere',
    nonRespondents: 'Ikke-respondenter',
    confirmMoveToDeclined: 'Flyt til afvist?',
    confirmMoveToDeclinedMessage:
      'Er du sikker på, at du manuelt vil flytte {firstName} til afvist?',
    confirmMoveToAttending: 'Flyt til deltagere?',
    confirmMoveToAttendingMessage:
      'Er du sikker på, at du manuelt vil flytte {firstName} til deltagere?',
  },
  auth: {
    signIn: 'Velkommen',
    signOut: 'Log ud',
    signUp: 'Tilmeld dig',
    signUpWithEmail: 'Tilmeld dig med e-mail',
    welcomeBack: 'Velkommen tilbage',
    welcome: 'Velkommen',
    verifyEmailWaiting: 'Verifierer e-mail...',
    enterEmail: 'E-mail',

    enterPassword: 'Adgangskode',
    createPassword: 'Opret adgangskode',
    confirmPasswordLabel: 'Bekræft adgangskode',
    passwordsDoNotMatch: 'Adgangskoderne matcher ikke',
    emailPlaceholder: 'mitnavn@email.com',
    passwordPlaceholder: 'Indtast adgangskode',
    continueWithEmail: 'Fortsæt',
    signInWithEmail: 'Log ind med e-mail',
    signInWithGoogle: 'Log ind med Google',
    continueWithSSO: 'Fortsæt med SSO',
    chooseSignInMethod: 'Vælg din login-metode',
    organizationId: 'Organisations-ID',
    organizationIdPlaceholder: 'Indtast dit organisations-ID',
    cannotBeLeftBlank: 'Kan ikke efterlades tom',
    notValidEmail: 'Ikke en gyldig e-mail',
    notValidPassword: 'Ikke en gyldig adgangskode',
    somethingWentWrongSSO:
      'Noget gik galt ved forsøg på at logge dig ind med single-sign on',
    errorSigningIn: 'Fejl ved login',
    errorSigningUp: 'Fejl under tilmelding',
    logout: 'Log ud',
    invalidCredentials: 'Ugyldige legitimationsoplysninger',
    emailNotAllowedForSignup:
      'Du kan ikke tilmelde dig med denne e-mail. Kontakt din administrator.',
    signingUpForCompany: 'Tilmelding til {companyName}',
    verifyEmailTitle: 'Tjek din indbakke',
    verifyEmailDescription:
      'Vi har sendt dig et verifikationslink. Åbn e-mailen for at bekræfte din konto.',
    verifyEmailSentTo: 'Sendt til {email}',
    verifyEmailCompanyLine:
      'Når du har bekræftet, færdiggør vi opsætningen for {companyName}.',
    verifyEmailCta: 'Tilbage til login',
  },
  navigation: {
    dashboard: 'Dashboard',
    createEvent: 'Opret Hubbl event',
    employeeOverview: 'Medarbejderoversigt',
    eventsOverview: 'Eventoversigt',
    interestAnalytics: 'Interesseanalyse',
    eventAnalytics: 'Eventanalyse',
    settings: 'Indstillinger',
    general: 'Generelt',
    profile: 'Profil',
    slackIntegration: 'Slack Integration',
    integrations: 'Integrationer',
    adminManagement: 'Administratorer',
    viewingAs: 'Ser som',
    admin: 'Admin',
    employee: 'Medarbejder',
    home: 'Hjem',
    createHubbl: 'Opret Hubbl',
    colleagues: 'Kolleger',
    previousEvents: 'Tidligere events',
  },
  dashboard: {
    welcome: 'Velkommen',
    welcomeDescription: 'Se nedenfor for hvad der sker på',
    socialActivities: 'Sociale aktiviteter',
    noSocialActivities: 'Ingen sociale aktiviteter',
    noActivitiesMatchFilters:
      'Ingen aktiviteter matcher dine nuværende filtre. Prøv at justere dine filterindstillinger ovenfor.',
    loadingSocialActivities: 'Indlæser dine sociale aktiviteter...',
    myOwn: 'Mine egne',
    accepted: 'Accepteret',
    declined: 'Afvist',
    pending: 'Afventer',
    completed: 'Fuldført',
    onboardingProgress: 'Opsætningsstatus',
    inviteColleagues: 'Inviter kolleger',
    createFirstEvent: 'Opret første event',
    integrateSlackTeams: 'Integrer Slack/Teams',
    connectCalendar: 'Forbind kalender',
    stepsCompleted: '{completed} af {total} trin fuldført',
    allStepsCompleted: 'Alt er sat op!',
    clickToComplete: 'Klik for at fuldføre',
    createYourFirstEvent: 'Opret dit første event',
    createFirstEventDescription:
      'Kom i gang ved at oprette dit første event for at engagere dit team og bygge arbejdspladsforbindelser.',
    eventTipsTitle: 'Event-tips',
    eventTipsDescription:
      'Opsæt påmindelser for bedre fremmøde og brug tags til at organisere dine events.',
    noEventsYet: 'Ingen events endnu',
    noEventsDescription:
      'Opret dit første event for at begynde at engagere dit team og spore analyser.',
    eventTip1:
      'Automatiske påmindelser retter sig kun mod ikke-svarere, hvilket reducerer spam og forbedrer fremmødet.',
    eventTip2:
      'Tilføj obligatoriske spørgsmål før eventet for at indsamle diætbehov og præferencer før RSVP.',
    eventTip3:
      'Brug AI til at generere komplette eventdetaljer, spørgsmål og beskrivelser på sekunder.',
    eventTip4: 'Aktiver QR-kode check-in til hurtig, kontaktløs eventindgang.',
    eventTip5:
      'Integrer med Slack og Teams for at sende eventnotifikationer direkte til dine teamkanaler.',
    eventTip6:
      'Eksporter alle svar og analyser til CSV med ét klik til nem deling med køkkener.',
  },
  activities: {
    groupActivity: 'Gruppeaktivitet',
    connect: 'Connect',
    event: 'Event',
    announcement: 'Meddelelse',
    groupNotFound: 'Gruppe ikke fundet',
    connectNotFound: 'Forbindelse ikke fundet',
    eventNotFound: 'Event ikke fundet',
    loading: 'Indlæser...',
    join: 'Deltag',
    leave: 'Forlad',
    accept: 'Accepter',
    decline: 'Afvis',
    clickToAccept: 'Klik for at acceptere',
    completed: '✓ Fuldført',
    declined: '✗ Afvist - Klik for at ændre',
    declinedClickToChange: '✗ Afvist - Klik for at ændre',
    tasksNotAvailable: 'Opgaver ikke tilgængelige',
    needToJoinForTasks:
      'Du skal deltage i denne gruppe for at få adgang til opgaverne.',
    needToAcceptForTasks:
      'Du skal acceptere denne Connect for at få adgang til opgaverne.',
    chatNotAvailable: 'Chat ikke tilgængelig',
    downloadApp: 'Download Hubbl-appen',
    scanQRCode: 'Scan denne QR-kode med din telefon for at downloade appen',
    declineActivity: 'Afvis',
    declineActivityMessage:
      'Er du sikker på, at du vil afvise denne gruppeaktivitet?',
    leaveActivity: 'Forlad aktivitet',
    leaveActivityMessage:
      'Er du sikker på, at du vil forlade denne gruppeaktivitet?',
    declineConnect: 'Afvis Connect',
    declineConnectMessage: 'Er du sikker på, at du vil afvise denne Connect?',
    keepInvitation: 'Behold invitation',
    stayInActivity: 'Bliv i aktivitet',
    joined: 'Deltager',
    groupAttendees: 'Gruppedeltagere',
    you: 'Dig',
    clickToSeeAll: 'Klik for at se alle deltagere',
    customActivity: 'Tilpasset aktivitet',
  },
  events: {
    createEvent: 'Opret gruppeaktivitet',
    createEventDescription: 'Opret en gruppeaktivitet for dine kolleger',
    createHubblEvent: 'Opret Hubbl Event',
    createHubblEventDescription:
      'Her kan du oprette et nyt event hos {companyName}.',
    editEvent: 'Rediger Event',
    eventDetails: 'Eventdetaljer',
    activityDetails: 'Aktivitetsdetaljer',
    activityRequired: 'Aktivitet er påkrævet',
    whoCanSeeThis: 'Hvem kan se denne aktivitet?',
    visibilityFilters: 'Synlighedsfiltre',
    invitedUsers: 'Inviterede brugere',
    recurring: 'Tilbagevendende',
    goBack: 'Gå tilbage',
    type: 'Type',
    startTime: 'Starttid',
    endTime: 'Sluttid',
    maxParticipants: 'Maks. deltagere',
    additionalDetails: 'Yderligere detaljer',
    tasks: 'Opgaver',
    noTasksYet: 'Ingen opgaver endnu',
    pressEnterToCreate: 'Tryk Enter for at oprette',
    groupNotFound: 'Gruppe ikke fundet',
    groupActivity: 'Gruppe aktivitet',
    connectNotFound: 'Connect ikke fundet',
    clickToAccept: 'Klik for at acceptere',
    tasksNotAvailable: 'Opgaver ikke tilgængelige',
    declineActivity: 'Afvis',
    declineActivityMessage:
      'Er du sikker på, at du vil afvise denne gruppe aktivitet?',
    leaveActivity: 'Forlad aktivitet',
    leaveActivityMessage:
      'Er du sikker på, at du vil forlade denne gruppe aktivitet?',
    keepInvitation: 'Behold invitation',
    stayInActivity: 'Bliv i aktivitet',
    declineConnect: 'Afvis',
    declineConnectMessage:
      'Er du sikker på, at du vil afvise denne forbindelse?',
    createActivity: 'Opret aktivitet',
    chatNotAvailable: 'Chat ikke tilgængelig',
    downloadApp: 'Download Hubbl appen',
    scanQRCode: 'Scan denne QR-kode med din telefon for at downloade appen',
    createConnectDescription: 'Opret en pause for at forbinde med en kollega',
    startDateTimeRequired: 'Startdato og -tid er påkrævet',
    addTasks: 'Tilføj opgaver',
    selectActivity: 'Vælg aktivitet',
    chooseActivityOrCreate: 'Vælg en aktivitet eller opret din egen',
    orCreateYourOwn: 'Eller opret din egen',
    writeCustomActivity: 'Skriv din brugerdefinerede aktivitet',
    clickToViewUserProfile: 'Klik for at se brugerprofil',
    viewProfile: 'Se profil',
    department: 'Afdeling',
    company: 'Virksomhed',
    officeLocation: 'Kontorplacering',
    started: 'Startede',
    interests: 'Interesser',
    unassign: 'Fjern tildeling',
    assignMyself: 'Tildel mig selv',
    assignOthers: 'Tildel andre',
    willBeAssignedLater: 'Vil blive tildelt senere',
    unassigned: 'Ikke tildelt',
    previewDescription: 'Sådan vil din aktivitet se ud for kolleger:',
    preview: 'Forhåndsvisning',
    unlimited: 'Ubegrænset',
    willBeRecurringActivity: 'Dette vil være en tilbagevendende aktivitet',
    deadlinePassed: 'Deadline overskredet',
    rsvpToday: 'RSVP i dag',
    rsvpTomorrow: 'RSVP i morgen',
    rsvpInDays: 'RSVP om {days} dage',
    rsvpInOneHour: 'RSVP om 1 time',
    rsvpInHours: 'RSVP om {hours} timer',
    rsvpInOneMinute: 'RSVP om 1 minut',
    rsvpInMinutes: 'RSVP om {minutes} minutter',
    rsvpInSeconds: 'RSVP om {seconds} sekunder',
    noDeadline: 'Ingen deadline',
    comingSoon: 'Kommer snart',
    groupChatComingSoon:
      '🚧 Vi bygger stadig web gruppechat oplevelsen! Vores udviklere arbejder hårdt på at give dig de samme fantastiske gruppechat funktioner, du elsker på mobil. I mellemtiden, tag din telefon og fortsæt samtalen med dine {count} kolleger! 📱✨',
    connectChatComingSoon:
      '🚧 Vi bygger stadig web chat oplevelsen! Vores udviklere arbejder hårdt på at give dig de samme fantastiske chat funktioner, du elsker på mobil. I mellemtiden, tag din telefon og fortsæt samtalen! 📱✨',
    answerQuestions: 'Besvar spørgsmål',
    enterYourAnswer: 'Indtast dit svar',
    enterAdditionalComments: 'Indtast yderligere kommentarer',
    user: 'Bruger',
    checkedInAt: 'Tjekket ind kl.',
    declinedAt: 'Afvist kl.',
    extraInfo: 'Ekstra info',
    maxParticipantsDescription:
      'Indstil det maksimale antal deltagere for denne aktivitet',
    declineEvent: 'Afvis',
    declineEventMessage: 'Er du sikker på, at du vil afvise denne event?',
    leaveEvent: 'Forlad event',
    leaveEventMessage: 'Er du sikker på, at du vil forlade denne event?',
    stayInEvent: 'Bliv i event',
    createOneOnOneConnection: 'Opret 1-til-1 Connect',
    dateAndTime: 'Dato og tid',
    endOptional: 'Slut (valgfrit)',
    tasksDescription:
      'Skal du delegere nogen opgaver mellem dig og din kollega?',
    tasksOptional: 'Opgaver (valgfrit)',
    makeRecurringActivity: 'Gør dette til en tilbagevendende aktivitet',
    createConnection: 'Opret Connect',
    colleaguesAttended: 'kolleger deltog',
    colleaguesAttending: 'kolleger deltager',
    attendedThankYou: '✓ Deltog - Tak for din anmeldelse!',
    reviewRequired: '📝 Anmeldelse påkrævet - Klik for at anmelde',
    attended: '✓ Deltog',
    attending: '✓ Deltager',
    declinedClickToChange: '✗ Afvist - Klik for at ændre',
    eventPassed: 'Event overstået',
    join: 'Deltag',
    attendees: 'Deltagere',
    invited: 'Inviteret',
    event: 'Event',
    upcoming: 'Kommende',
    completed: 'Afsluttet',
    deadline: 'Deadline',
    dayOfEvent: 'Eventdag',
    eventEnd: 'Event slut',
    evaluationEnd: 'Evaluering slut',
    evaluationReminder: 'Eval reminder',
    eventNotFound: 'Event ikke fundet',
    noLocationSpecified: 'Ingen placering angivet',
    checkedIn: 'Tjekket ind',
    notCheckedIn: 'Ikke tjekket ind',
    deleteEvent: 'Slet event',
    deleteEventTitle: 'Slet event?',
    deleteEventMessage:
      'Er du sikker på, at du vil slette dette event? Denne handling kan ikke fortrydes, og alle deltagere vil blive underrettet.',
    deleteEventSuccess: 'Event slettet',
    deleteEventError: 'Kunne ikke slette event',
  },
  filters: {
    filters: 'Filtre',
    status: 'Status:',
    types: 'Typer:',
    search: 'Søg',
    searchPlaceholder: 'Søg aktiviteter, personer eller lokationer...',
    closeSearch: 'Luk søgning',
    all: 'Alle',
    myOwn: 'Mine egne',
    pending: 'Afventer',
    accepted: 'Accepteret',
    declined: 'Afvist',
    events: 'Events',
    groups: 'Grupper',
    connects: 'Connects',
    startMonth: 'Start måned',
    endMonth: 'Slut måned',
    organizationalFilters: 'Organisatoriske filtre',
    resetFilters: 'Nulstil filtre',
    applyFilters: 'Anvend filtre',
  },
  analytics: {
    interestAnalytics: 'Interesseanalyse',
    eventAnalytics: 'Eventanalyse',
    eventAnalyticsTitle: 'Event analyse',
    eventAnalyticsDescription: 'Indsigter for {companyName} events',
    insightsForCompany: 'Indsigter for {companyName}',
    failedToLoadEventAnalytics: 'Kunne ikke indlæse event analyse',
    csv: 'CSV',
    pdf: 'PDF',
    eventAnalyticsReport: 'Event analyse rapport',
    interestAnalyticsReport: 'Interesse analyse rapport',
    generating: 'Genererer...',
    errorGeneratingPDF: 'Fejl ved generering af PDF. Prøv igen.',
    metric: 'Metrik',
    value: 'Værdi',
    totalUsers: 'Samlede brugere',
    usersWithInterests: 'Brugere med interesser',
    interestCompletionRate: 'Interesse færdiggørelse rate (%)',
    averageInterestsPerUser: 'Gennemsnitlige interesser per bruger',
    interestDistribution: 'Interesse fordeling',
    topInterests: 'Top interesser',
    interest: 'Interesse',
    count: 'Antal',
    percentage: 'Procent',
    generatedOn: 'Genereret den:',
    executiveSummary: 'Ledelsesoversigt',
    visualAnalytics: 'Visuel analyse',
    interestDistributionBreakdown: 'Interesse fordeling opdeling',
    interestRange: 'Interesse område',
    zeroInterests: '0 interesser',
    oneToFiveInterests: '1-5 interesser',
    sixToTenInterests: '6-10 interesser',
    tenToTwentyInterests: '10-20 interesser',
    twentyPlusInterests: '20+ interesser',
    userCount: 'Bruger antal',
    percentageOfTotal: 'Procent af samlet',
    mostPopularInterests: 'Mest populære interesser',
    selectionCount: 'Valg antal',
    reportGeneratedBy:
      'Rapport genereret af WorkBreak Interesse Analyse Dashboard',
    filteredBy: 'Filtreret efter:',
    allLocations: 'Alle lokationer',
    allCompanies: 'Alle virksomheder',
    allDepartments: 'Alle afdelinger',
    selectedDepartments: 'Valgte afdelinger',
    company: 'Virksomhed:',
    totalEvents: 'Samlede events',
    avgResponseRate: 'Gennemsnitlig svarprocent',
    evaluationRate: 'Evaluering rate',
    evaluationResponseRate: 'Evaluering svar rate',
    sendEvaluationReminder: 'Send evalueringsreminder',
    totalAttendees: 'Samlede deltagere',
    eventPerformanceOverview: 'Event præstation oversigt',
    event: 'Event',
    date: 'Dato',
    attendees: 'Deltagere',
    responseRate: 'Svarprocent',
    satisfaction: 'Tilfredshed',
    organizationalBreakdown: 'Organisatorisk opdeling',
    department: 'Afdeling',
    location: 'Lokation',
    events: 'Events',
    eventId: 'Event ID',
    eventTitle: 'Event titel',
    eventEmoji: 'Event emoji',
    startDate: 'Start dato',
    endDate: 'Slut dato',
    totalInvited: 'Samlet inviteret',
    totalDeclined: 'Samlet afvist',
    totalNoResponse: 'Samlet ingen svar',
    responseRatePercent: 'Svarprocent (%)',
    evaluationCompletionRatePercent: 'Evaluering færdiggørelse rate (%)',
    averageSatisfactionScore: 'Gennemsnitlig tilfredshedsscore',
    hasEvaluation: 'Har evaluering',
    evaluationQuestions: 'Evaluering spørgsmål',
    evaluationResponses: 'Evaluering svar',
    tags: 'Tags',
    yes: 'Ja',
    no: 'Nej',
    organizationalInterestHeatmap: 'Organisatorisk interesse heatmap',
    filterByLocation: 'Filtrer efter lokation',
    filterByCompany: 'Filtrer efter virksomhed',
    filterByDepartments: 'Filtrer efter afdelinger',
    popularInterestsAcrossDepartments:
      'Populære interesser på tværs af valgte afdelinger',
    clickInterestToSeeEmployees:
      'Klik på en interesse for at se hvilke medarbejdere der valgte den på tværs af de filtrerede afdelinger',
    // Heatmap specific translations
    high: 'Høj',
    mediumHigh: 'Medium-Høj',
    medium: 'Medium',
    low: 'Lav',
    veryLow: 'Meget lav',
    selectAll: 'Vælg alle',
    deselectAll: 'Fravælg alle',
    selected: 'valgt',
    basedOnDepartments:
      'Baseret på {count} afdeling{plural} med {totalUsers} medarbejdere i alt',
    topInterestsLabel: 'Top interesser:',
    heatmapDescription:
      'Viser interesse engagement rates på tværs af forskellige organisatoriske enheder. Højere rates indikerer mere aktiv interessevalg i disse afdelinger. Klik på et afdelingskort for at se interesserne i den afdeling.',
    // Interest trends chart
    month: 'Måned',
    interestTrendsDescription:
      'Viser hvordan interesse engagement har ændret sig over tid. Interesse færdiggørelse rate angiver procentdelen af brugere der har valgt interesser.',
    // Event details
    failedToAddEmployeeToEvent: 'Kunne ikke tilføje medarbejder til event:',
    interestTrendsOverTime: 'Interessetendenser over tid',
    interestDistributionAcrossUsers: 'Interessefordeling på tværs af brugere',
    noInterestsFoundForDepartment: 'Ingen interesser fundet for denne afdeling',
    interestCategoriesDistribution: 'Interessekategorier fordeling',
    allInterests: 'Alle interesser',
    totalInterests: 'samlede interesser',
    viewAllInterests: 'Se alle interesser',
    clickBarToSeeEmployees:
      'Klik på en søjle for at se hvilke medarbejdere der valgte den interesse',
    top10MostPopularInterests: 'Top 10 mest populære interesser',
    eventsCreatedInPeriod: 'Events oprettet i denne periode',
    averageResponseRate: 'Gennemsnitlig svarprocent',
    topEvent: 'Top event',
    noEvents: 'Ingen events',
    noEventsToDisplay: 'Ingen events at vise',
    evaluationCompletionRate: 'Evaluering færdiggørelse rate',
    upcomingEvents: 'Kommende events',
    eventsScheduledAhead: 'Events planlagt fremad',
    error: 'Fejl',
    evaluationAnalytics: 'Evaluering analyse',
    evaluationDescription:
      'Forståelse af hvor godt events evalueres og hvad feedback afslører om medarbejder tilfredshed.',
    totalEvaluations: 'Samlede evalueringer',
    eventsWithEvaluationForms: 'Events med evalueringsformularer',
    completedEvaluations: 'Fuldførte evalueringer',
    evaluationsWithResponses: 'Evalueringer med svar',
    evaluationCoverage: 'Evaluering dækning',
    questionResponseRate: 'Spørgsmål svarprocent',
    averageCompletionRate: 'Gennemsnitlig færdiggørelse rate',
    outOfFiveStars: 'Ud af 5.0 stjerner',
    evaluationBreakdown: 'Evaluering opdeling',
    eventsWithEvaluations: 'Events med evalueringer',
    ofTotalEvents: 'af samlede events',
    eventsWithoutEvaluations: 'Events uden evalueringer',
    completionRate: 'Færdiggørelse rate',
    averageEvaluationCompletion: 'Gennemsnitlig evaluering færdiggørelse',
    responseQuality: 'Svar kvalitet',
    excellent: 'Fremragende',
    good: 'God',
    needsImprovement: 'Behøver forbedring',
    last3Months: 'Sidste 3 måneder',
    currentPeriod: 'Nuværende periode',
    scheduled: 'Planlagt',
    bestPerformance: 'Bedste præstation',
    basedOnSatisfactionScores: 'Baseret på tilfredshedsscore',
    responseRateTrends: 'Svarprocent tendenser',
    responseRateDescription:
      'Viser hvordan svarprocenter har ændret sig over tid. Højere procenter indikerer bedre medarbejder engagement med events.',
    monthlyEventActivity: 'Månedlig event aktivitet',
    monthlyEventDescription:
      'Viser event oprettelses mønstre og deltagelsestendenser efter måned. Events (venstre akse) og deltagere (højre akse) bruger separate skalaer for bedre synlighed.',
    quickStats: 'Hurtige statistikker',
    averageAttendees: 'Gennemsnitlige deltagere',
    eventPerformance: 'Event præstation',
    topDepartments: 'Top afdelinger',
    scanned: 'Scannet',
    noShow: 'Mødte ikke op',
    invited: 'Inviteret',
    evaluation: 'Evaluering',
    qrCodes: 'QR koder',
    status: 'Status',
    upcoming: 'Kommende',
    completed: 'Fuldført',
    cards: 'Kort',
    table: 'Tabel',
    eventAnalyticsNotAvailable: '📊 Event analyse ikke tilgængelig',
    eventAnalyticsNotSetUp:
      'Event analyse er endnu ikke blevet sat op for din virksomhed.',
    clickToGenerateAnalytics:
      'Klik på knappen nedenfor for at behandle alle eksisterende eventsdata og generere analyse.',
    generateAnalytics: 'Generer analyse',
    processingMayTakeTime:
      'Dette kan tage et par minutter afhængigt af antallet af events i din virksomhed.',
    eventAnalyticsMinimumRequirement:
      'Event analyse vil blive aktiveret, når du har 5 events, der er gået forbi.',
    interestAnalyticsMinimumRequirement:
      'Interesse analyse vil blive aktiveret, når du har 15 medarbejdere, der har tilmeldt sig.',
    interestAnalyticsMinimumRequirementTitle: 'Flere medarbejdere påkrævet',
    interestAnalyticsMinimumRequirementDescription:
      'Interesse analyse kræver mindst 15 medarbejdere for at give meningsfulde indsigt. Når du når denne tærskel, vil du kunne se detaljerede analyser om dit teams interesser og præferencer.',
    organizationalEventInsights: 'Organisatoriske event indsigter',
    organizationalEventDescription:
      'Forståelse af hvordan forskellige afdelinger engagerer sig med virksomheds events og identificering af samarbejdsmuligheder.',
    departmentsAnalyzed: 'Afdelinger analyseret',
    totalOrganizationalUnitsWithEventData:
      'Samlede organisatoriske enheder med eventsdata',
    acrossAllDepartments: 'På tværs af alle afdelinger',
    mostActiveDepartment: 'Mest aktive afdeling',
    eventsOrganized: 'Events organiseret',
    departmentPerformance: 'Afdeling præstation',
    response: 'svar',
  },
  modals: {
    confirm: 'Bekræft',
    cancel: 'Annuller',
    close: 'Luk',
    save: 'Gem',
    delete: 'Slet',
    edit: 'Rediger',
    create: 'Opret',
    join: 'Deltag',
    leave: 'Forlad',
    accept: 'Accepter',
    decline: 'Afvis',
  },
  forms: {
    required: 'Påkrævet',
    optional: 'Valgfri',
    invalid: 'Ugyldig',
    valid: 'Gyldig',
    cannotBeLeftBlank: 'Kan ikke efterlades tom',
    notValidEmail: 'Ikke en gyldig e-mail',
    notValidPassword: 'Ikke en gyldig adgangskode',
    emailPlaceholder: 'mitnavn@email.com',
    passwordPlaceholder: 'Indtast adgangskode',
    namePlaceholder: 'Indtast navn',
    titlePlaceholder: 'Indtast titel',
    descriptionPlaceholder: 'Indtast beskrivelse',
  },
  buttons: {
    continue: 'Fortsæt',
    back: 'Tilbage',
    next: 'Næste',
    save: 'Gem',
    cancel: 'Annuller',
    delete: 'Slet',
    edit: 'Rediger',
    create: 'Opret',
    join: 'Deltag',
    leave: 'Forlad',
    accept: 'Accepter',
    decline: 'Afvis',
    close: 'Luk',
    search: 'Søg',
    filter: 'Filtrer',
    download: 'Download',
    upload: 'Upload',
    share: 'Del',
    copy: 'Kopier',
    refresh: 'Opdater',
    retry: 'Prøv igen',
    tryAgain: 'Prøv igen',
    submit: 'Indsend',
    loadMore: 'Vis flere',
  },
  ai: {
    getAISuggestion: 'Få AI-forslag',
    prompt: {
      title: '🤖 Generér event med AI',
      subtitle:
        "Beskriv dit event, vi skaber resten (fx. 'Sommerfest, juni 25. deadline 15 maj')",
      placeholder: 'Beskriv dit event i naturligt sprog...',
      triggerLabel: 'Generér med AI',
      showExamples: 'Vis eksempler',
      hideExamples: 'Skjul eksempler',
      generate: 'Generér',
      generating: 'Genererer...',
      examples: [
        'Sommerfest i Tivoli, 25. juni næste år fra 18:00 til 22:00, deadline 15 maj.',
        'Teamfrokost næste måned kl. 12 i kantinen',
        'Kvartalsvis all-hands møde',
        'Social kaffepause for engineering team om morgen',
        'Fredagsbar, næste måned, deadline en uge før',
        'Julefrokost på Pressen, 3 timer, 15. december, deadline 26. november',
        'Wellness workshop, 90 minutter i februar, fra 10:00 til 11:30',
      ],

      clear: 'Ryd',
      detailedGeneration: 'Detaljeret generering',
      detailedGenerationDescription: 'Langsommere, men mere detaljeret',
      fastGeneration: 'Hurtig generering',
      fastGenerationDescription: 'Hurtig, men mindre detaljeret',
      generatingCoverImage: 'AI genererer cover billede...',
      generatingField: 'AI genererer...',
    },
    imageGeneration: {
      title: 'AI billede generering',
      placeholder:
        'Beskriv det cover billede du vil generere til dit arrangement',
      clear: 'Ryd',
      generateImage: 'Generer billede',
      generating: 'Genererer...',
      keyboardShortcut: 'Tryk Cmd/Ctrl + Enter for at generere',
      tooltip: {
        generate: 'Generer AI cover billede',
        hide: 'Skjul AI billede generator',
      },
    },
  },
  interests: {
    requestNewInterest: 'Anmod om ny interesse',
    newInterestRequestSubject: '💡 Anmodning om ny interesse',
    newInterestRequestBody:
      'Hej team Hubbl 👋,\n\nJeg kunne ikke finde den interesse jeg ledte efter i Hubbl appen. Kunne I venligst tilføje:\n\nInteresse: [Beskriv venligst den interesse du gerne vil have tilføjet]\nKategori: [Hvilken kategori skal denne tilhøre?]\n\nTak!',
  },
  invite: {
    inviteMessage:
      'Du er blevet inviteret til at deltage i {companyName} på Hubbl! Forbind med dine kolleger, opdag fælles interesser og byg meningsfulde relationer gennem sjove aktiviteter og events.',
  },
  visibility: {
    editVisibility: 'Rediger synlighed',
    saveVisibility: 'Gem synlighed',
    cancel: 'Annuller',
    noVisibilityRestrictions:
      'Ingen synlighedsbegrænsninger - event vil være synlig for alle medarbejdere',
  },
  attendees: {
    morePerson: 'flere person',
    people: 'personer',
  },
  questions: {
    myResponses: 'Mine spørgsmålssvar',
    noResponse: 'Intet svar givet',
    required: 'Påkrævet',
    requiredMessage: 'Dette spørgsmål er påkrævet',
    questionResponses: 'Spørgsmålssvar',
    attendingUsers: 'Deltagende brugere',
    unrespondedEmails: 'Ubesvarede medarbejdere',
    noUnrespondedEmails: 'Ingen ubesvarede medarbejdere',
    evaluationRespondents: 'Hvem svarede',
    nonRespondents: 'Hvem svarede ikke',
  },
  evaluation: {
    eventEvaluation: 'Event evaluering',
    noEvaluationConfigured: 'Ingen evaluering konfigureret for denne event.',
    evaluationDetails: 'Evalueringsdetaljer',
    evaluationLink: 'Evalueringslink',
    copyLink: 'Kopier link',
    copied: 'Kopieret!',
    evaluationQuestions: 'Evaluering spørgsmål',
    evaluationReminders: 'Evaluering påmindelser',
    noQuestionsConfigured: 'Ingen spørgsmål konfigureret',
    noRemindersConfigured: 'Ingen påmindelser konfigureret',
    evaluationResponses: 'Evaluering svar',
    questionNumber: 'Spørgsmål {number}',
    noResponsesYet: 'Ingen svar endnu',
    aggregatedResponses: 'Samlede svar',
    numberOfResponses: 'Antal svar',
    thankYou: 'Tak for din anmeldelse',
    feedbackHelpful:
      'Din feedback hjælper os med at forbedre fremtidige events!',
    review: 'Anmeldelse',
    required: 'Påkrævet',
    requiredMessage: 'Dette spørgsmål er påkrævet',
    enterAnswer: 'Indtast dit svar',
    additionalComments: 'Indtast eventuelle yderligere kommentarer',
    back: 'Tilbage',
    submit: 'Indsend',
    next: 'Næste',
    pleaseEvaluateEvent: 'Tag venligst et øjeblik til at evaluere denne event.',
    evaluationReminder: 'Evaluering påmindelse',
    evaluationReminderBody:
      'Hej,\n\nDette er en venlig påmindelse om at fuldføre evalueringen for eventet "{eventTitle}" {eventEmoji}.\n\nDin feedback er vigtig for os og hjælper os med at forbedre fremtidige events.\n\nKlik her for at fuldføre evalueringen:\n{evaluationLink}\n\nMed venlig hilsen,\n{adminName}',
    evaluationResponseCount: 'af {totalCount} deltagere svarede',
    showMoreResponses: 'Vis {count} flere svar',
    showLessResponses: 'Vis færre',
  },
  groups: {
    colleaguesAttended: 'kolleger deltog',
    colleagues: 'kolleger',
    waitingForOthers: 'Du oprettede dette - Venter på andre at deltage',
    joinedViewDetails: '✓ Deltager - Se detaljer',
    declinedClickToChange: '✗ Afvist - Klik for at ændre',
    completedViewDetails: '✓ Fuldført - Se detaljer',
    join: 'Deltag',
  },
  connects: {
    acceptedYour: 'accepterede din',
    youCreated: 'du oprettede',
    with: 'med',
    waitingForSomeone: '(venter på nogen at deltage)',
    oneOnOneConnect: '1-til-1 Connect',
    connectedViewDetails: '✓ Forbundet - Se detaljer',
    declinedClickToChange: '✗ Afvist - Klik for at ændre',
    completedViewDetails: '✓ Fuldført - Se detaljer',
    clickToAccept: 'Klik for at acceptere',
  },
  validation: {
    endTimeTooEarly: 'Sluttid skal være mindst 10 minutter efter starttid',
    selectActivity: 'Vælg mindst én aktivitet',
  },
  calendar: {
    with: 'med',
    interest: 'interesse',
    interests: 'interesser',
    oneOnOneConnect: '1-til-1 Forbindelse',
    groupActivity: 'Gruppeaktivitet',
    matchingInterestsLabel: 'Matchende interesser:',
    matchingInterestsDescription:
      'Du har {interestNames} som matchende {interestText} med {firstName}.',
    // Calendar integration
    calendarIntegration: 'Kalenderintegration',
    calendarIntegrationDescription:
      'Synkroniser automatisk Hubbl event invitationer og deadlines til din kalender.',
    calendarIntegrationProgressDescription:
      'Klik for at se teammedlemmernes kalenderintegrationsstatus',
    connected: '✓ Forbundet',
    notConnected: 'Ikke forbundet',
    connectedTo: 'Forbundet til {provider}',
    googleCalendar: 'Google Calendar',
    connectedOn: 'Forbundet den {date}',
    connectCalendarDescription:
      'Forbind din kalender for automatisk at synkronisere event invitationer, RSVP deadlines og bekræftede events.',
    noManualDownloads: 'Events og deadlines synkroniserer automatisk',
    eventsAppearInstantly: 'Invitationer vises øjeblikkeligt i din kalender',
    eventsAppearInstantlyAttend:
      'Event invitationer, RSVP deadlines og bekræftede events vil blive tilføjet til din kalender automatisk.',
    calendarConnectedSuccessfully: 'Kalender forbundet!',
    connecting: 'Forbinder...',
    connectGoogleCalendar: 'Forbind Google Calendar',
    connectOutlookCalendar: 'Forbind Microsoft Outlook',
    disconnecting: 'Afbryder...',
    disconnect: 'Afbryd',
    disconnectConfirmation:
      'Er du sikker på at du vil afbryde din kalender? Fremtidige events vil ikke længere blive tilføjet automatisk.',
    failedToConnectCalendar: 'Kunne ikke forbinde kalender',
    failedToDisconnectCalendar: 'Kunne ikke afbryde kalender',
    popupBlocked: 'Popup blokeret',
    popupBlockedDescription:
      'Din browser blokerede kalender forbindelses-popup. Klik fortsæt for at gennemføre forbindelsen i dette vindue.',
    continueHere: 'Fortsæt',
    connectingYourCalendar: 'Forbinder din kalender...',
    pleaseWaitConnection: 'Vent venligst mens vi fuldfører forbindelsen.',
    calendarConnectedTitle: 'Kalender forbundet!',
    eventsWillSyncAutomatically:
      'Event invitationer og deadlines vil nu synkronisere automatisk til din kalender.',
    returnToSettings: 'Tilbage til indstillinger',
    connectionFailed: 'Forbindelse fejlede',
    close: 'Luk',
    connectYourProvider: 'Forbind din {provider}?',
    eventsWillSyncWhenAttend:
      'Event invitationer og RSVP deadlines vil automatisk synkroniseres til din kalender. Du skal stadig svare i Hubbl.',
    skipForNow: 'Spring over',
    connectProvider: 'Forbind {provider}',
    calendarConnectedEventsSync:
      '✓ Kalender forbundet! Events vil synkronisere automatisk.',
    calendarConnectedSyncAutomatically:
      'Kalender forbundet - events synkroniserer automatisk',
    failedToConnectTryAgain:
      'Kunne ikke forbinde kalender. Prøv venligst igen.',
    chooseYourCalendarProvider: 'Vælg din kalenderudbyder:',
  },
  user: {
    noDepartment: 'Ingen afdeling',
    noSubCompany: 'Ingen undervirksomhed',
    noLocation: 'Ingen lokation',
  },
  hubbl: {
    recurringDescription:
      'Dette vil oprette en tilbagevendende 1-til-1 hubbl som kolleger kan deltage i ugentligt.',
    howItWorks:
      'Sådan fungerer det: Din 1-til-1 vil være synlig for kolleger som derefter kan acceptere at deltage. Du bliver matchet med den der accepterer først, og du modtager en notifikation for at koordinere detaljerne.',
  },
  onboarding: {
    describeYourself: 'Beskriv dig selv',
  },
  profileCompletion: {
    cardTitle: 'Færdiggør din profil',
    cardDescription: 'Hjælp kolleger med at lære dig bedre at kende',
    completed: 'færdig',
    completeNow: 'Færdiggør nu',
    addPhoto: 'Tilføj et profilbillede',
    addInterests: 'Tilføj mindst 5 interesser',
    photo: 'profilbillede',
    interests: 'interesser',
    bannerTitle: 'Din profil er ufuldstændig',
    bannerMessage:
      'Tilføj dine {items} for at hjælpe kolleger med at forbinde med dig',
    completeProfile: 'Færdiggør profil',
  },
  errors: {
    somethingWentWrong: 'Noget gik galt',
    invalidCredentials: 'Ugyldige legitimationsoplysninger',
    accessDenied: 'Adgang nægtet',
    permissionDenied: 'Tilladelse nægtet',
    networkError: 'Netværksfejl',
    serverError: 'Serverfejl',
    unknownError: 'Ukendt fejl',
    notFound: 'Ikke fundet',
    notAvailable: 'Ikke tilgængelig',
    loading: 'Indlæser...',
    error: 'Fejl',
  },
  messages: {
    loading: 'Indlæser...',
    error: 'Fejl',
    success: 'Succes',
    noData: 'Ingen data tilgængelig',
    noResults: 'Ingen resultater fundet',
    tryAgain: 'Prøv igen',
    somethingWentWrong: 'Noget gik galt',
    invalidCredentials: 'Ugyldige legitimationsoplysninger',
    accessDenied: 'Adgang nægtet',
    permissionDenied: 'Tilladelse nægtet',
    networkError: 'Netværksfejl',
    serverError: 'Serverfejl',
    unknownError: 'Ukendt fejl',
  },
  scenes: {
    event: {
      visibleFor: 'Event synlig for:',
      scanToDownloadApp: 'Scan for at downloade app',
      youAttending: '✅ Du deltager! ',
      youDeclined: '❌ Du har afvist denne event',
      registerForEvent: 'Tilmeld dig eventen',
      processing: 'Behandler {action}...',
      youAlreadyReacted: 'Du har allerede reageret på denne event',
      deadlinePassed: 'Deadlinen for denne event er overskredet',
      eventAlreadyPassed: 'Denne event er allerede afsluttet',
      reviewEvent: 'Review event',
      thankYouForReview: 'Tak for din anmeldelse {emoji}',
      eventHasPassed: 'Eventen er afsluttet',
      deadlineHasPassed: 'Deadline overskredet',
      leaveEvent: 'Forlad event',
      changeResponse: 'Ændre svar',
      joinEvent: 'Deltag i event',
      declineEvent: 'Afvis',
      colleaguesAttending: 'Kolleger deltager',
    },
    onboarding: {
      pickInterests:
        'Vælg op til {maxInterests} interesser der beskriver dig som person, så du kan dele lidt om dig selv.',
      saving: 'Gemmer...',
      saveInterests: 'Gem ({count}/{maxInterests}) interesser',
      selectToContinue: 'Vælg {remaining} for at fortsætte',
      interestsWhyWeNeedThis: 'Hvorfor har vi brug for dine interesser?',
      interestsBenefitTitle: 'Sådan hjælper vi dig og dit team',
      interestsBenefitEmployee:
        '✨ For dig: Bliv inviteret til aktiviteter der matcher dine interesser og mød kolleger med samme passion',
      interestsBenefitManagement:
        '🎯 For firma-arrangementer: Din virksomhed bruger dette til at planlægge bedre, mere relevante events som folk rent faktisk vil deltage i',
      interestsSkipConfirmTitle: 'Spring interessevalg over?',
      interestsSkipConfirmMessage:
        'Du kan altid tilføje dine interesser senere for at hjælpe os med at skabe bedre events til dig og finde kolleger med lignende interesser.',
      interestsSkipForNow: 'Spring over for nu',
      interestsSkipConfirmButton: 'Spring over for nu',
      interestsSkipCancelButton: 'Fortsæt med at vælge',
      interestsSkippedWelcomeBack: 'Velkommen tilbage! 👋',
      interestsSkippedDescription:
        'Sidste gang sprang du over at tilføje interesser. Tag et øjeblik til at tilføje dem nu, så vi kan anbefale aktiviteter du vil elske og hjælpe med at planlægge events skræddersyet til dig.',
      addProfilePhoto: 'Tilføj et profilbillede',
      helpColleaguesRecognize:
        'Hjælp dine kolleger med at genkende dig ved at tilføje et profilbillede.',
      uploading: 'Uploader...',
      finish: 'Afslut',
      skipForNow: 'Spring over for nu',
      areYouSureNoPhoto:
        'Er du sikker på, at du ikke vil have et profilbillede?',
      thisIsHowPeopleRecognize:
        'Det er sådan, folk omkring dig kan genkende dig.',
      yesSkip: 'Ja, spring over',
      noGoBack: 'Nej, gå tilbage',
      describeYourself: 'Beskriv dig selv',
    },
    createEvent: {
      enterEventTitle: 'Indtast titel',
      enterEventLocation: 'Indtast lokation',
      uploadCoverImage: 'Skal uploade et coverbillede',
      editVisibility: 'Rediger synlighed',
      additionalInviteOptions: 'Yderligere invitationsmuligheder',
      addQuestions: 'Tilføj spørgsmål',
      createQuestion: 'Opret spørgsmål',
      enableEventEvaluation: 'Aktivér event evaluering',
      addEvaluationQuestions: 'Tilføj evalueringsspørgsmål',
      addEvaluationReminder: 'Tilføj evalueringsreminder',
      addReminder: 'Tilføj reminder',
      enableQRTickets: 'Aktivér QR-billetter til deltagere',
      createEvent: 'Opret event',
      // New translations for hardcoded text
      eventDetails: '1. Eventoplysninger',
      eventTitle: 'Titel',
      eventDescription: 'Beskrivelse',
      eventEmoji: 'Emoji',
      eventLocation: 'Lokation',
      coverImage: 'Cover billede',
      schedulingDeadline: '2. Planlægning & deadline',
      startDateTime: 'Start dato & tid',
      endDateTime: 'Slut dato & tid',
      publishDateTime: 'Publiceringsdato & tid',
      deadlineQuestion:
        'Vil du tilføje en deadline for hvornår man skal svare?',
      visibilitySection: '3. Hvem kan se dette event?',
      noAdditionalInvites: 'Ingen yderligere invitationer',
      inviteMyUsers: 'Inviter også medarbejdere du har inviteret',
      inviteAllUsers: 'Inviter også alle inviterede medarbejdere',
      preAttendanceForm: '4. Pre-deltagelsesformular',
      preAttendanceQuestions: 'Spørgsmål at stille før deltagelse',
      postEventEvaluation: '5. Efter-event evaluering',
      evaluationIntroduction: 'Introduktion',
      evaluationQuestions: 'Evalueringsspørgsmål',
      evaluationEndDate: 'Evaluerings slutdato',
      evaluationRemindersDefault:
        'Evalueringsreminder (standard til dag og uge efter event)',
      notifications: '6. Notifikationer',
      eventRemindersDefault: 'Event reminder (standard til uge og dag før)',
      qrTicketSystem: '7. QR billet system',
      qrTicketsEnabled:
        'Admins får adgang til en QR kode scanner og deltagere får en QR kode for at kunne tjekke ind.',
      qrTicketsDisabled: 'QR billetter er deaktiveret for dette event.',
      // Event tags
      eventTags: 'Event tags',
      addTagPlaceholder: 'Tilføj tag og tryk Enter eller komma...',
      tags: 'Tags',
      searchPlaceholder:
        'Søg events efter titel, lokation, tags eller beskrivelse...',
      // Validation messages
      eventTitleRequired: 'Eventtitel kan ikke være tom',
      eventDescriptionRequired: 'Eventbeskrivelse kan ikke være tom',
      emojiRequired: 'Du skal vælge en emoji',
      eventLocationRequired: 'Eventlokation kan ikke være tom',
      startDateTimeRequired: 'Start dato og tid kan ikke være tom',
      startDateTimeInPast: 'Start dato og tid kan ikke være i fortiden',
      endDateTimeBeforeStart: 'Slutdato kan ikke være før startdato',
      deadlineAfterStart: 'Deadline kan ikke være efter startdato',
      publishDateTimeRequired: 'Publiceringsdato og tid kan ikke være tom',
      evaluationEndDateRequired: 'Evaluerings slutdato kan ikke være tom',
      reminderTimeRequired: 'Remindertid er påkrævet',
      evaluationEnabledAddQuestion:
        'Evaluering er aktiveret, tilføj venligst mindst ét spørgsmål.',
      fillRequiredFields:
        'Udfyld venligst alle påkrævede felter før du opretter et event.',
      selectStartDateReminder:
        'Vælg venligst en startdato før du tilføjer en reminder.',
      selectEndDateEvaluationReminder:
        'Vælg venligst en slutdato før du tilføjer en evalueringsreminder.',
      // Default evaluation description
      defaultEvaluationDescription:
        'Tag venligst et øjeblik til at evaluere eventet {eventTitle}. Din feedback hjælper os med at forbedre fremtidige events! 📝',
      // Question management
      editQuestion: 'Rediger spørgsmål',
      addNewQuestion: 'Tilføj nyt spørgsmål',
      writeQuestionHere: 'Skriv dit spørgsmål her',
      questionType: 'Spørgsmålstype',
      singleChoice: 'Enkeltvalg',
      multipleChoice: 'Flervalg',
      freeText: 'Fritekst',
      options: 'Muligheder',
      enterOptionHere: 'Indtast mulighed {number} her',
      optionCannotBeEmpty: 'Mulighed kan ikke være tom',
      questionTextCannotBeEmpty: 'Spørgsmålstekst kan ikke være tom',
      allowFreeTextAnswer: 'Tillad fritekst svar',
      questionIsRequired: 'Spørgsmål er påkrævet',
      changesSavedSuccessfully: 'Ændringer gemt succesfuldt!',
      questionAddedSuccessfully: 'Spørgsmål tilføjet succesfuldt!',
      saveChanges: 'Gem ændringer',
      saveQuestion: 'Gem spørgsmål',
      cancel: 'Annuller',
      // Evaluation question management
      editEvaluationQuestion: 'Rediger evalueringsspørgsmål',
      addNewEvaluationQuestion: 'Tilføj nyt evalueringsspørgsmål',
      // Chart tooltips and descriptions
      totalSelections: 'totale valg',
      users: 'brugere',
      ofTotalUsers: 'af alle brugere',
      categoryBreakdownDescription:
        'Viser fordelingen af interessevalg på tværs af forskellige kategorier. Hver kategori repræsenterer en gruppe af relaterede interesser.',
      // Draft management
      draftUpdatedSuccessfully: 'Kladde opdateret succesfuldt',
      draftSavedSuccessfully: 'Kladde gemt succesfuldt',
      pleaseEnterEventTitleToSaveDraft:
        'Indtast venligst en eventtitel for at gemme som kladde',
      draftDeletedSuccessfully: 'Kladde slettet succesfuldt',
      deleteDraftTitle: 'Slet kladde',
      deleteDraftMessage:
        'Er du sikker på, at du vil slette "{title}"? Denne handling kan ikke fortrydes.',
      saveDraft: 'Gem kladde',
      savingDraft: 'Gemmer...',
      loadDraft: 'Indlæs kladde',
      // Image upload
      onlyImageFilesAllowed: 'Kun JPG, JPEG eller PNG filer er tilladt.',
      fileSizeExceedsLimit: 'Filstørrelse overstiger 5MB.',
      failedToUploadImage: 'Kunne ikke uploade billede.',
      imageSelected: 'Billede valgt: {filename}',
      loading: 'Indlæser...',
      dragAndDropImage: 'Træk og slip et billede her, eller klik for at vælge',
      // Events overview
      eventsOverview: 'Events oversigt',
      eventsOverviewDescription:
        'Her kan du få et overblik over alle events hos {companyName}.',
      created: 'Oprettet',
      event: 'Event',
      startDate: 'Start dato',
      publishDate: 'Publiceringsdato',
      rsvpDeadline: 'RSVP deadline',
      attendees: 'Deltagere',
      declined: 'Afvist',
      questions: 'Spørgsmål',
      status: 'Status',
      upcoming: 'Kommende',
      completed: 'Afsluttet',
      loadingMoreEvents: 'Indlæser flere events...',
      dash: '—',
      sortAscending: '↑',
      sortDescending: '↓',
      noEvents: 'Ingen events endnu',
      noEventsDescription:
        'Kom i gang ved at oprette dit første event. Events hjælper med at bringe dit team sammen og skabe forbindelser.',
      noSearchResults: 'Ingen events fundet',
      noSearchResultsDescription:
        'Prøv at justere dine søgeord eller filtre for at finde det, du leder efter.',
      // Response rate
      responseRate: 'Svar rate',
      ofEmployeesResponded: 'af {totalCount} medarbejdere svarede',
      sendManualEmail: 'Send manuel e-mail',
      increaseResponseRate: 'Øg svarprocenten',
      declinedUsers: 'Medarbejdere der har afvist',
      qrCodeCheckInStatus: 'QR kode check-in status',
      checkedIn: 'Tjekket ind',
      notCheckedIn: 'Ikke tjekket ind',
      qrCodesEnabled: 'QR koder er aktiveret for denne event',
      emailReminderSubject: 'Reminder: {eventTitle} {eventEmoji}',
      emailReminderBody:
        'Hej,\n\nDette er en venlig påmindelse om eventet "{eventTitle}" {eventEmoji}.\n\nSvar venligst på event invitationen.\n\nMed venlig hilsen,\n{adminName}',
      // Heatmap and analytics
      interestRate: 'Interesse rate:',
      selected: 'valgt',
      // Draft manager
      errorReadingFile: 'Fejl ved læsning af fil',
      errorConvertingBase64ToFile: 'Fejl ved konvertering af base64 til fil:',
      emptyImageFilename: 'tom.jpg',
      coverImageFilename: 'cover-billede.jpg',
      // Question Bank
      questionBank: 'Spørgsmålsbank',
      questionBankDescription: 'Vælg et spørgsmål for at tilføje det til dit event',
      standardQuestions: 'Standard spørgsmål',
      companySavedQuestions: 'Gemte spørgsmål',
      savedQuestions: 'Gemte spørgsmål',
      noSavedQuestions: 'Ingen gemte spørgsmål endnu. Gem spørgsmål når du opretter dem for at opbygge din spørgsmålsbank.',
      loadFromBank: 'Hent fra spørgsmålsbank',
      standardTag: 'Standard',
      savedTag: 'Gemt',
      editSavedQuestion: 'Rediger gemt spørgsmål',
      editSavedQuestionNotice: 'Ændringer vil opdatere dette spørgsmål i din virksomheds spørgsmålsbank.',
      saveToQuestionBank: 'Gem til spørgsmålsbank',
      editBankQuestion: 'Rediger bankspørgsmål',
      updateBankQuestion: 'Opdater bankspørgsmål',
      bankQuestionUpdated: 'Bankspørgsmål opdateret',
      questionDeletedSuccessfully: 'Spørgsmål slettet fra bank',
    },
    colleaguesOverview: {
      loadingTeamMembers: 'Indlæser teammedlemmer...',
      noTeamMembersFound: 'Ingen teammedlemmer fundet. Prøv at opdatere siden.',
      discoverColleagues: 'Udforsk dine kolleger hos {companyName}',
      yourCompany: 'din virksomhed',
      discoverFilteredColleagues:
        'Udforsk dine {filteredCount} af {totalCount} kolleger hos {companyName}',
      deleteUser: 'Slet bruger',
      deleteUserConfirmTitle: 'Slet bruger?',
      deleteUserConfirmMessage:
        'Er du sikker på, at du vil slette {userName} permanent? Denne handling kan ikke fortrydes.',
      deleteUserSuccess: 'Bruger slettet',
      deleteUserError: 'Kunne ikke slette bruger',
      deleting: 'Sletter...',
      actions: 'Handlinger',
    },
    userProfile: {
      userNotFound: 'Bruger ikke fundet',
      failedToLoadUser: 'Kunne ikke indlæse brugerdetaljer',
    },
    getStarted: {
      whatDescribesSituation: 'Hvad beskriver din situation bedst?',
      useInWorkplace: 'Jeg vil bruge Hubbl på min arbejdsplads',
      manageCoworkingSpace:
        'Jeg administrerer et coworking space og vil bruge Hubbl med kollegerne',
      useInUniversity: 'Jeg vil bruge Hubbl på mit universitet',
      manageIncubator:
        'Jeg administrerer en inkubator og vil bruge Hubbl blandt start-ups',
      inviteYourTeam: 'Inviter dit team',
      addEmployeesViaCSVDescription:
        'Tilføj medarbejdere via CSV-upload eller manuelt. Du kan også springe over og invitere dem senere.',
      csvFormatDescription: 'CSV format: email, fullName, department, jobTitle',
      orAddEmployeesManually: 'Eller tilføj medarbejdere manuelt:',
      setupYourCompany: 'Lad os sætte din virksomhed op på Hubbl',
      setupYourCompanyDescription: 'Fortæl os lidt om dig og din virksomhed',
      yourFullName: 'Dit fulde navn',
      companyName: 'Virksomhedsnavn',
      readyToLaunch: 'Klar til start!',
      readyToLaunchDescription:
        'Gennemgå dine virksomhedsoplysninger og klik opret for at komme i gang',
      summary: 'Oversigt',
      admin: 'Administrator',
      employeesToInvite: 'Medarbejdere at invitere',
      createCompany: 'Opret virksomhed',
      creatingCompany: 'Opretter din virksomhed...',
      employee: 'medarbejder',
      employees: 'medarbejdere',
    },
    createHubbl: {
      inviteColleagues: 'Inviter kolleger',
      inviteColleaguesDescription:
        'Inviter specifikke kolleger til denne aktivitet',
      addInvitations: 'Tilføj invitationer',
      inviting: 'Inviterer {name}',
      invitingCount: 'Inviterer {count} kolleger',
      youInviting: 'Du inviterer {name}',
      youInvitingCount: 'Du inviterer {count} kolleger',
      whoCanSee: 'Hvem kan se denne aktivitet?',
      whoCanSeeDescription: 'Vælg hvilke kolleger der skal se denne aktivitet',
      everyone: 'Alle',
      allDepartments: 'Alle afdelinger',
      filters: '{count} filter{plural}',
      departments: '{count} afdelinger',
      createHubbl: 'Opret en Hubbl',
      createHubblDescription:
        'Forbind med kolleger på tværs af teams, opdag fælles interesser og byg meningsfulde arbejdspladsrelationer',
      hubblConnect: 'Hubbl Connect',
      hubblConnectDescription:
        'Forbind en-til-en med kolleger der deler dine interesser for kaffe, frokost eller enhver aktivitet',
      hubblGroup: 'Hubbl Group',
      hubblGroupDescription:
        'Opret gruppeaktiviteter der bringer kolleger sammen omkring fælles interesser og hobbyer',
      findColleagues: 'Find kolleger med lignende interesser',
      breakDownSilos: 'Bryd team-silos ned',
      flexibleScheduling: 'Fleksibel planlægning',
      discoverPerspectives: 'Opdag nye perspektiver',
      findYourPeople: '🎯 Find dine mennesker',
      findYourPeopleDescription:
        'Forbind med kolleger der deler dine passioner og interesser',
      connectAcrossDepartments: 'Forbind på tværs af afdelinger',
      sharePassions: 'Del dine passioner med andre',
      meetNewColleagues: 'Mød nye kolleger',
      buildFriendships: 'Byg varige venskaber',
      expandNetwork: '🌟 Udvid dit netværk',
      expandNetworkDescription:
        'Mød kolleger fra forskellige teams der deler dine interesser',
      connectionsDisabled: '1-til-1 Connects er i øjeblikket deaktiveret',
      groupsDisabled: 'Gruppeaktiviteter er i øjeblikket deaktiveret',
      activityDetails: 'Aktivitetsdetaljer',
      whatActivityOrganize: 'Hvilken aktivitet vil du gerne organisere?',
      activityPlaceholder: 'f.eks. Kaffepause, Teamfrokost, Gå-møde',
      activityRequired: 'Aktivitet er påkrævet',
      locationOptional: 'Lokation (valgfri)',
      locationPlaceholder: 'f.eks. Hovedkontor, Mødelokale A, Lokalt café',
      additionalDetails: 'Yderligere detaljer (valgfri)',
      additionalDetailsPlaceholder:
        'Eventuelle yderligere oplysninger deltagerne skal vide...',
      endOptional: 'Slut (valgfri)',
      startRequired: 'Startdato og -tid er påkrævet',
      makeRecurring: 'Gør dette til en tilbagevendende aktivitet',
      recurringDescription:
        'Dette vil oprette en tilbagevendende gruppeaktivitet som kolleger kan deltage i ugentligt.',
      howItWorks:
        'Sådan fungerer det: Din gruppeaktivitet vil være synlig for kolleger som derefter kan deltage. Du modtager notifikationer når folk deltager, og du kan koordinere detaljerne sammen.',
      addTasks: 'Tilføj opgaver',
      tasksDescription:
        'Skal du delegere nogle opgaver blandt andre kolleger for at organisere denne event?',
      tasksOptional: 'Opgaver (valgfri)',
      cancel: 'Annuller',
      createActivity: 'Opret aktivitet',
      creating: 'Opretter...',
      endTimeValidationError:
        'Sluttidspunkt skal være mindst 10 minutter efter starttidspunkt',
      activityRequiredError: 'Aktivitet er påkrævet',
      startDateTimeRequiredError: 'Startdato og -tid er påkrævet',
    },
    activity: {
      youCreatedWaiting: 'Du oprettede dette - Venter på at nogen deltager',
      connected: '✓ Forbundet',
      clickToAccept: 'Klik for at acceptere',
      completed: '✓ Fuldført',
      declinedClickChange: '✗ Afvist - Klik for at ændre',
      decline: 'Afvis',
      leave: 'Forlad',
      chatNotAvailable: 'Chat ikke tilgængelig',
      needToAcceptConnect:
        'Du skal acceptere denne Connect for at få adgang til chatten.',
      needToJoinGroup:
        'Du skal deltage i denne gruppe for at få adgang til chatten.',
      comingSoon: 'Kommer snart',
      downloadApp: 'Download app',
      scanQRCode: 'Scan QR-kode',
      downloadToCalendar: 'Download til kalender',
      interestsInCommon: '👋 Interesser I begge har til fælles',
      groupAttendees: 'Gruppedeltagere',
      clickToSeeAll: 'Klik for at se alle deltagere',
      moreAttendees: '+{count} flere',
      details: 'Detaljer',
      tasks: 'Opgaver',
      chat: 'Chat',
      chatWith: 'Chat med {name}',
      created: 'Oprettet {date}',
      waitingForOthers: 'Venter på at andre deltager',
      acceptedYour: '{name} accepterede din Hubbl Connect',
      youCreated: '{activity} du oprettede',
      with: '{activity} med {name}',
      waitingForSomeone: 'Venter på at nogen deltager',
      connectedViewDetails: 'Forbundet - Se detaljer',
      completedViewDetails: 'Fuldført - Se detaljer',
      connectNotFound: 'Forbindelse ikke fundet',
      tasksNotAvailable: 'Opgaver ikke tilgængelige',
      needToAcceptConnectTasks:
        'Du skal acceptere denne Connect for at få adgang til opgaverne.',
      declineConnect: 'Afvis Connect',
      declineConnectMessage: 'Er du sikker på at du vil afvise denne Connect?',
      keepInvitation: 'Behold invitation',
      loading: 'Indlæser...',
    },
    table: {
      avatar: 'Avatar',
      nameTitle: 'Navn og titel',
      department: 'Afdeling',
      company: 'Virksomhed',
      officeLocation: 'Kontorlokation',
      started: 'Startede',
      calendarIntegration: 'Kalender',
      funFact: 'Fun fact',
      interests: 'Interesser',
      clickToViewProfile: 'Klik for at se profil',
      na: 'N/A',
      cards: 'Kort',
      table: 'Tabel',
    },
    profile: {
      userProfile: 'Brugerprofil',
      loadingUserProfile: 'Indlæser brugerprofil...',
      interests: '🎯 Interesser',
      matchingInterests: '👋 Matchende interesser med dig',
      more: '+{count} flere',
      department: 'Afdeling',
      company: 'Virksomhed',
      officeLocation: 'Kontorlokation',
      startedAtCompany: 'Startede i virksomheden',
      funFact: '💡 Fun fact',
      inviteToHubbl: 'Inviter {name} til en Hubbl (kommer snart)',
    },
    dashboard: {
      welcomeBack: 'Velkommen tilbage, {name}! 👋',
      upcomingActivities:
        'Her er dine kommende sociale aktiviteter hos {companyName}',
      loadingSocialActivities: 'Indlæser dine sociale aktiviteter...',
      socialActivities: 'Sociale aktiviteter',
      noSocialActivities: 'Ingen sociale aktiviteter fundet',
      noActivitiesMatchFilters:
        'Ingen aktiviteter matcher dine nuværende filtre',
    },
    pastEvents: {
      previousEvents: 'Tidligere events',
      completeTimeline: 'Komplet tidslinje over tidligere events',
      loadingPreviousEvents: 'Indlæser dine tidligere events...',
      loadPreviousEvents: 'Indlæs tidligere events',
      noPreviousEvents: 'Ingen tidligere events fundet',
      noPastEventsToDisplay:
        'Der er ingen tidligere events at vise i øjeblikket.',
    },
    deadline: {
      rsvpWithin: 'RSVP inden for {time} {unit}',
      deadlinePassed: 'Deadline overskredet',
      leftToRespond: 'Tilbage at svare',
      deadline: 'Deadline: {time}',
    },
    ticket: {
      yourEventTicket: 'Din event billet',
      checkedInAt: '✅ Tjekket ind kl. {time}',
    },
    eventEndpoint: {
      eventNotFound: 'Event ikke fundet',
      eventNotFoundOrUnauthorized: 'Event ikke fundet eller uautoriseret',
      accessDenied: 'Du har ikke adgang til denne event',
      attendees: 'Deltagere ({count})',
    },
    auth: {
      signInWithGoogle: 'Log ind med Google',
      youDontHaveAccess: 'Du har ikke adgang til denne app',
      failedToSetupAccount: 'Kunne ikke opsætte din konto. Prøv igen.',
      youDontHaveAccessToApp: 'Du har ikke adgang',
      failedToAssociateUser:
        'Kunne ikke tilknytte bruger til virksomhed efter forsøg',
      failedToMoveUser: 'Kunne ikke flytte bruger til virksomhed efter forsøg',
    },
    slack: {
      noOrganizationalStructure: 'Ingen organisationsstruktur',
      ssoNotEnabled:
        'SSO-integration er muligvis ikke aktiveret for denne virksomhed.',
      noSubCompaniesFound: 'Ingen datterselskaber fundet',
      noSubCompaniesInStructure:
        'Ingen datterselskaber fundet i organisationsstrukturen.',
      subCompanySlackChannels: 'Slack-kanaler i datterselskaber',
      configureSlackWebhooks:
        'Konfigurer Slack webhook URLs for hver datterselskab for at aktivere målrettede notifikationer. Hver datterselskab kan have sin egen dedikerede Slack-kanal til event opdateringer.',
      slackWebhookUrl: 'Slack Webhook URL',
      noSlackWebhookConfigured: 'Ingen Slack webhook konfigureret',
      edit: 'Rediger',
      saving: 'Gemmer...',
      save: 'Gem',
      cancel: 'Annuller',
      savedSuccessfully: '✓ Gemt succesfuldt!',
      failedToSave: "✗ Kunne ikke gemme. Tjek venligst URL'en og prøv igen.",
      slackIntegration: 'Slack Integration',
      configureSlackIntegration:
        'Konfigurer din Slack integration for at modtage event notifikationer og opdateringer. Opsæt generelle indstillinger og konfigurer specifikke kanaler for hvert datterselskab.',
      general: 'Generelt',
      nothingHereYet: 'Intet her endnu.',
      sendSlackNotification: 'Send Slack Notifikation',
      slackNotificationSent: 'Slack notifikation sendt succesfuldt!',
      failedToSendSlackNotification:
        'Kunne ikke sende Slack notifikation. Prøv venligst igen.',
      sendSlackNotificationConfirmTitle: 'Send Slack Notifikation',
      sendSlackNotificationConfirmMessage:
        'Er du sikker på, at du vil sende en Slack notifikation igen for dette event? Dette vil sende en besked til relevante Slack kanaler.',
      sendSlackNotificationConfirm: 'Send Notifikation',
    },
    integrations: {
      noOrganizationalStructure: 'Ingen organisationsstruktur',
      ssoNotEnabled:
        'SSO-integration er muligvis ikke aktiveret for denne virksomhed.',
      noSubCompaniesFound: 'Ingen datterselskaber fundet',
      noSubCompaniesInStructure:
        'Ingen datterselskaber fundet i organisationsstrukturen.',
      subCompanyChannels: '{integration} kanaler i datterselskaber',
      configureWebhooks:
        'Konfigurer {integration} webhook URLs for hver datterselskab for at aktivere målrettede notifikationer. Hver datterselskab kan have sin egen dedikerede kanal til event opdateringer.',
      webhookUrl: 'Webhook URL',
      noWebhookConfigured: 'Ingen webhook konfigureret',
      savedSuccessfully: '✓ Gemt!',
      failedToSave: "✗ Kunne ikke gemme. Tjek venligst URL'en og prøv igen.",
      configureIntegrations:
        'Konfigurer dine integrationer for at modtage event notifikationer og opdateringer.',
      slack: 'Slack',
      teams: 'Microsoft Teams',
      deleteIntegration: 'Slet integration',
      deleteIntegrationConfirmTitle: 'Slet integration?',
      deleteIntegrationConfirmMessage:
        'Dette vil fjerne alle webhook konfigurationer. Du skal konfigurere alt igen, hvis du vil bruge integrationer igen.',
      deleteIntegrationConfirm: 'Ja, Slet Alt',
      choosePlatformTitle: 'Vælg din integrationsplatform',
      choosePlatformDescription:
        'Vælg hvilken kommunikationsplatform du vil bruge til event notifikationer. Du kan konfigurere webhooks efter valg af platform.',
      slackDescription: 'Send event notifikationer til Slack kanaler',
      teamsDescription: 'Send event notifikationer til Teams kanaler',
    },
    adminManagement: {
      title: 'Administratorer',
      description:
        'Administrer administratorrettigheder for dit team. Forfrem medarbejdere til administratorer eller lokale administratorer.',
      currentAdmins: 'Nuværende administratorer',
      currentAdminsDescription:
        'Disse brugere har fuld administrativ adgang til at administrere events, analyser og indstillinger.',
      currentLocalAdmins: 'Lokale administratorer',
      currentLocalAdminsDescription:
        'Disse brugere har begrænset administrativ adgang til deres område.',
      promoteEmployees: 'Forfrem medarbejdere',
      promoteEmployeesDescription:
        'Søg og forfrem medarbejdere for at give dem administratorrettigheder.',
      noAdmins: 'Ingen administratorer fundet',
      noLocalAdmins: 'Ingen lokale administratorer fundet',
      noEmployees: 'Ingen medarbejdere at forfremme',
      searchEmployees: 'Søg medarbejdere...',
      promote: 'Forfrem',
      promoteToAdmin: 'Forfrem til administrator',
      promoteToLocalAdmin: 'Forfrem til lokal administrator',
      demote: 'Fjern rettigheder',
      promoting: 'Forfremmer...',
      demoting: 'Fjerner...',
      promotedSuccessfully: 'Brugerrettigheder opdateret',
      demotedSuccessfully: 'Brugerrettigheder fjernet',
      cannotDemoteLastAdmin:
        'Kan ikke degradere den sidste administrator. Der skal være mindst én administrator i virksomheden.',
      confirmDemote: 'Bekræft fjernelse af rettigheder',
      confirmDemoteMessage:
        'Er du sikker på, at du vil fjerne rettigheder fra {name}? De vil miste adgang til administratorfunktioner.',
      confirmPromote: 'Bekræft forfremmelse til administrator',
      confirmPromoteMessage:
        'Er du sikker på, at du vil forfremme {name} til administrator? De vil få adgang til alle administratorfunktioner, herunder eventadministration, analyser og virksomhedsindstillinger.',
      confirmPromoteToLocalAdmin:
        'Bekræft forfremmelse til lokal administrator',
      confirmPromoteToLocalAdminMessage:
        'Er du sikker på, at du vil forfremme {name} til lokal administrator? De vil få begrænset administrativ adgang.',
      errorPromoting: 'Kunne ikke opdatere brugerrettigheder. Prøv igen.',
      errorDemoting: 'Kunne ikke fjerne brugerrettigheder. Prøv igen.',
      cannotDemoteSelf:
        'Du kan ikke degradere dig selv. Bed en anden administrator om at fjerne dine rettigheder.',
      localAdminComingSoon: 'Lokal administratoradministration kommer snart!',
      comingSoon: '(Kommer Snart)',
      loadingAdmins: 'Indlæser administratorer...',
      loadingEmployees: 'Indlæser medarbejdere...',
      admin: 'Administrator',
      localAdmin: 'Lokal Administrator',
      employee: 'Medarbejder',
      you: '(Dig)',
    },
  },
};

export default language;
